import { ApiError, isValidImage } from '@gorila-shared-ui/components';
import { FILE_TYPE_DOCUMENT, FILE_TYPE_IMAGE } from '../constants/app';
import { FileType } from '../types/app';
import { fileRequest } from './api';

export const getFileUrl = async (path: string): Promise<{ url?: string; type?: FileType; error?: ApiError }> => {
  const response = await fileRequest(path);

  return {
    url: `${response?.data?.url}`,
    type: isValidImage(path) ? FILE_TYPE_IMAGE : FILE_TYPE_DOCUMENT,
    error: response?.error as any,
  };
};
